/** Pill badge shown above the hero headline (no unsourced user counts). */
export const HERO_VALUE_PROPOSITION = "Family wealth management for India";

/** Visible label on the hero dashboard preview widget. */
export const HERO_SAMPLE_DATA_LABEL = "Sample data";

/** Feature highlights used instead of unsourced user/asset totals on the landing page. */
export const LANDING_TRUST_HIGHLIGHTS = [
  { value: "12+", label: "Asset types tracked" },
  { value: "Free", label: "Plan to get started" },
] as const;

/** Honest CTA copy — no unsourced user totals. */
export const LANDING_CTA_SUBHEADLINE =
  "Start free with tools built for Indian investors and families.";

export {
  HOME_PAGE_SEO_DESCRIPTION,
  HOME_PAGE_SEO_KEYWORDS,
  HOME_PAGE_SEO_TITLE,
  SIGNUP_PAGE_SEO_DESCRIPTION,
  ABOUT_PAGE_SEO_TITLE,
  ABOUT_PAGE_SEO_DESCRIPTION,
  FAMILY_WEALTH_SEO_TITLE,
  FAMILY_WEALTH_SEO_DESCRIPTION,
  FAMILY_WEALTH_SEO_KEYWORDS,
  FEATURES_PAGE_SEO_TITLE,
  FEATURES_PAGE_SEO_DESCRIPTION,
  FEATURES_PAGE_SEO_KEYWORDS,
} from "@/lib/seoConfig";

export const AUTH_WELCOME_BLURB =
  "Track 12+ asset types, manage family wealth with shared goals and member profiles, split expenses, and plan your financial future with enterprise-grade security.";
